import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import { useEffect, useRef, useState } from "react";
import BlueButton from "../../Atoms/BlueButton";
import * as api from '../../../api';
import Step1 from "../../Components/FD10025/Step1";
import Step2 from "../../Components/FD10025/Step2";
import { useNavigate } from "react-router-dom";
import { validateStep1FD1002025 } from "../../Utils/Validator";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import BigH1 from "../../Atoms/BigH1";
import Popup from "../../Atoms/Popup";
import UploadProgressBar from "../../Atoms/UploadProgressBar";

const EditParticipation = (props) => {

    const navigate = useNavigate()

    const [projets, setProjets] = useState([]);
    const [deletedProjets, setDeletedProjets] = useState([]);

    const [step, setStep] = useState(1);
    const formRef = useRef(null);
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [participation, setParticipation] = useState(null);
    const [fullUser, setFullUser] = useState(null);
    const [dataSavedPopupOpen, setDataSavedPopupOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    //get event and user id from params
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");

        // if there is a addprojectfromportfolio=true, set the step to 2
        const addProjectFromPortfolio = new URLSearchParams(window.location.search).get("addprojectfromportfolio");
        if (addProjectFromPortfolio) {
            setStep(2);
        }
        // setUserId(userIdFromParam);
        // setEventId(eventIdFromParam);
        if (!eventIdFromParam || !userIdFromParam) {
            console.log("no event id or user id in url");
            return;
        }

        api.getEventById({ id: eventIdFromParam }).then((response) => {
            setEvent(response.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });

        //get the user
        refreshUser();
    }, [])

    function deleteParticipation() {
        if (window.confirm(i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer la participation ?" : "Are you sure you want to delete the participation ?")) {
            api.deleteParticipation(fullUser.user._id,event._id).then((response) => {
                // console.log(response);
                alert(i18n.language === "fr" ? "Participation supprimée" : "Participation deleted");
                if(props.fullUser?.user?.role !== "admin"){
                    navigate("/evenements");
                }else{
                    navigate("/admin/events");
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    function refreshUser(){
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        //get the user
        api.GetAllUserDataById({ id: userIdFromParam }).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setFullUser(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");

        if (!userIdFromParam || !eventIdFromParam || !fullUser) {
            return;
        }

        api.getUserParticipations({userid: userIdFromParam}).then((resParticipations) => {
            const matchingParticipation = resParticipations.data.find(participation => participation.eventId === eventIdFromParam);
            if(matchingParticipation) {
                console.log("matchingParticipation found :")
                console.log(matchingParticipation)
                setParticipation(matchingParticipation);

                //for each projet in participation, get the projet data from the user's company
                const projets = matchingParticipation.data.projets;
                if(projets){
                    projets.forEach((projet_id) => {
                        const project_from_company = fullUser.company.projects.find((projet) => projet._id === projet_id);
                        setProjets((prevProjets) => [...prevProjets, project_from_company]);
                    });
                }


                // setProjets(matchingParticipation.data.projets);
            }
        })
    }, [fullUser])


    // //parse eid from url and get event
    // useEffect(() => {
    //     const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
    //     if (eventIdFromParam) {
    //         api.getEventById({ id: eventIdFromParam }).then((response) => {
    //             setEvent(response.data);
    //             setLoading(false);
    //         }).catch((error) => {
    //             console.log(error);
    //         });
    //     }
    // }, [])

    //scroll to top on step change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step])

    const { i18n } = useTranslation('common');

    function submit(e) {
        e.preventDefault();

        if (fullUser.user.role === "admin"){
            alert("Les administrateurs ne peuvent pas s'inscrire à un événement");
            return;
        }

        if(!validateStep2()){
            setLoading(false);
            return;
        }

        api.LogFront("FD1002025 start submit (in edit)");

        const totalSizeOfFiles = projets.reduce((acc, projet) => {
            if(projet.newMedias){
                return acc + projet.newMedias.reduce((acc2, media) => {
                    return acc2 + media.file.size;
                }, 0);
            }
            return acc;
        }, 0);
        api.LogFront("totalSizeOfFiles : " + totalSizeOfFiles);

        setLoading(true);
        const submission = new FormData(e.target);

        submission.append("projets", JSON.stringify(projets));
        for (let i = 0; i < projets.length; i++) {
            // console.log("appending projet")
            // console.log(projets[i])

            if(projets[i].newMedias){
                for (let j = 0; j < projets[i].newMedias.length; j++) {
                    // console.log("appending file")
                    // console.log(projets[i].newMedias[j])
                    submission.append("file_" + projets[i].id_in_participation + "_" + j, projets[i].newMedias[j].file);
                }
            }
        }
        submission.append("userId", fullUser.user._id);
        submission.append("eventId", event._id);

        //start a timer to see how long it takes to upload
        const startTime = new Date().getTime();

        api.saveFD1002025(submission, onUploadProgress).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setLoading(false);
            if (response.data === "success") {
                //empty projets
                setProjets([]);
                refreshUser();
                setDataSavedPopupOpen(true);
            } else {
                api.LogFront("❌ FD1002025 error on submit (in edit) : " + response.data);
                
                alert("Erreur lors de l'enregistrement des données, assurez-vous que les fichiers ne dépassent pas 50Mo");
            }
        }).catch((error) => {
            const endTime = new Date().getTime();
            const timeOfCrash = endTime - startTime;

            console.log(error);
            api.LogFront("❌ FD1002025 error on submit (in edit) : " + error);
            api.LogFront("at uploadProgress : " + uploadProgress);
            api.LogFront("time of crash : " + timeOfCrash);

            //if the error is a network error, we can assume the user lost connection
            if (error.message === "Network Error") {
                alert("Erreur lors de l'enregistrement des données. Veuillez vérifier votre connexion internet et réessayer.");
                setLoading(false);
                return;
            }

            alert("Erreur lors de l'enregistrement des données. Veuillez contacter connectedby@via.fr si le problème persiste.");
        });
    }

    function onUploadProgress(progressEvent){
        const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setUploadProgress(percentCompleted);
    }

    function nextStep() {
        api.LogFront("FD1002025 next step (in edit), step before we go to next one : " + step);
        if (step === 1 && validateStep1()) {
            setStep(step + 1);
        }
    }

    function validateStep1() {
        api.LogFront("FD1002025 validate step 1 (in edit)");
        const form = new FormData(formRef.current);
        return validateStep1FD1002025(form,projets);
    }

    function validateStep2() {
        api.LogFront("FD1002025 validate step 2 (in edit) with projets :" + projets.length);
        //check thate there is at least one projet
        if (projets.length === 0) {
            alert(i18n.language === "fr" ? "Vous devez ajouter au moins un projet" : "You must add at least one project");
            return false;
        }

        return true;
    }

    if (loading) {
        return <Section className="padding">
            <Spinner/><br/>
            <UploadProgressBar uploadProgress={uploadProgress}/>
        </Section>
    }

    //if user doesnt have a company alert that they need to create one first
    if (fullUser && !fullUser.company) {
        return <Section className="padding"><BigH1>{i18n.language === "fr" ? "Vous devez créer une entreprise avant de vous inscrire à un événement" : "You need to create a company before registering for an event"}</BigH1></Section>
    }

    return (<>
        <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
            <img src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.logo_path} alt="Event Logo" style={{maxWidth:"150px"}} />
            <div>
                <BigH1 style={{fontSize:"65px", lineHeight:"70px", marginBottom:"20px"}}>{event.title_fr}</BigH1>
                <span style={{fontSize:"22px"}}>{i18n.language === "fr" ? "Voici les informations que vous avez saisi pour votre participation à cet événement. Vous pouvez les modifier si nécessaire." : "Here is the information you entered for your participation in this event. You can modify it if necessary."}</span>
            </div>
        </Section>
        {fullUser && participation &&
            <form onSubmit={submit} ref={formRef}>
                <Section className="padding" style={{ display: step === 1 ? 'block' : 'none' }}>
                <Step1 defaultValues={participation.data} />
                </Section>
                <Section className="padding" style={{ display: step === 2 ? 'block' : 'none' }}>
                    <Step2 fullUser={fullUser} projets={projets} setProjets={setProjets} deletedProjets={deletedProjets} setDeletedProjets={setDeletedProjets} />
                </Section>
                <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '40px' }}>
                    {step > 1 && <BlueButton onClick={(e) => { e.preventDefault(); setStep(step - 1) }}>{i18n.language === "fr" ? "Précédent" : "Previous"}</BlueButton>}
                    {step < 2 && <BlueButton onClick={(e) => { e.preventDefault(); nextStep() }}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Suivant" : "Next"}</BlueButton>}
                    {step === 2 && <BlueButton>{i18n.language === "fr" ? "Enregistrer" : "Save"}</BlueButton>}
                </Section>
                {step === 2 && <Section className="padding">
                    <BlueButton type="button" className="centered" style={{backgroundColor: "red"}} onClick={deleteParticipation}>{i18n.language === "fr" ? "Supprimer la participation" : "Delete participation"}</BlueButton>
                </Section>}
            </form>
        }
        {dataSavedPopupOpen && 
            <Popup close={() => navigate("/evenements")}>
                <span>{i18n.language === "fr" ? "Candidature enregistrée" : "Application saved"}</span>
                <br/>
                <BlueButton onClick={() => navigate("/evenements")}>
                    {i18n.language === "fr" ? "Fermer" : "Close"}
                </BlueButton>
            </Popup>
        }
    </>)
}

export default EditParticipation;